// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.offline-status {
  max-width: 1100px;
  margin: 10px auto 0;
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: var(--vb-radius-pill);
  padding: 8px 14px;
  font-size: 13px;
  box-shadow: var(--vb-shadow-sm);
  color: var(--vb-text);
}

.offline-status.offline {
  background: var(--vb-warning-soft);
  border-color: color-mix(in srgb, var(--vb-warning) 40%, transparent);
}

.offline-status.pending { background: var(--vb-primary-soft); }
.offline-status.failed { background: var(--vb-danger-soft); }
.offline-status.syncing,
.offline-status.online { background: var(--vb-success-soft); }

.status-main {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.status-icon { font-size: 16px; }
.offline-status.syncing .status-icon { animation: spin 1s linear infinite; }

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.status-text { flex: 1 1; font-weight: 650; }

.sync-button,
.sync-action-button {
  background: var(--vb-primary);
  color: var(--vb-primary-contrast);
  border: none;
  border-radius: var(--vb-radius-pill);
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.sync-button:disabled,
.sync-action-button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.details-toggle {
  background: none;
  border: none;
  color: inherit;
  font-size: 12px;
  cursor: pointer;
  padding: 2px 6px;
  font-weight: 650;
}

.sync-message,
.sync-details {
  margin-top: 8px;
  padding: 8px 10px;
  background: var(--vb-surface-2);
  border-radius: 10px;
  font-size: 12px;
  color: var(--vb-text-muted);
}

.sync-error,
.sync-errors {
  margin-top: 8px;
  padding: 8px;
  background: var(--vb-danger-soft);
  border-radius: 10px;
  color: var(--vb-danger);
  font-size: 12px;
}

.sync-details-header,
.sync-errors-header { font-weight: 700; margin-bottom: 6px; color: var(--vb-text); }

.sync-detail-item {
  display: flex;
  justify-content: space-between;
  margin: 4px 0;
  font-size: 12px;
}

.sync-detail-item .online { color: var(--vb-success); }
.sync-detail-item .offline { color: var(--vb-danger); }

.error-match { font-weight: 650; }
.error-message { margin-left: 4px; }

.sync-actions {
  margin-top: 8px;
  display: flex;
  gap: 8px;
}

@media (max-width: 768px) {
  .offline-status {
    margin: 10px 12px 0;
    border-radius: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/OfflineStatus.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,kCAAkC;EAClC,oCAAoC;EACpC,iBAAiB;EACjB,eAAe;EACf,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,oEAAoE;AACtE;;AAEA,0BAA0B,kCAAkC,EAAE;AAC9D,yBAAyB,iCAAiC,EAAE;AAC5D;yBACyB,kCAAkC,EAAE;;AAE7D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA,eAAe,eAAe,EAAE;AAChC,uCAAuC,kCAAkC,EAAE;;AAE3E;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,eAAe,SAAO,EAAE,gBAAgB,EAAE;;AAE1C;;EAEE,6BAA6B;EAC7B,iCAAiC;EACjC,YAAY;EACZ,oCAAoC;EACpC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,iCAAiC;EACjC,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;sBACsB,gBAAgB,EAAE,kBAAkB,EAAE,qBAAqB,EAAE;;AAEnF;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,eAAe;AACjB;;AAEA,4BAA4B,wBAAwB,EAAE;AACtD,6BAA6B,uBAAuB,EAAE;;AAEtD,eAAe,gBAAgB,EAAE;AACjC,iBAAiB,gBAAgB,EAAE;;AAEnC;EACE,eAAe;EACf,aAAa;EACb,QAAQ;AACV;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;EACrB;AACF","sourcesContent":[".offline-status {\n  max-width: 1100px;\n  margin: 10px auto 0;\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: var(--vb-radius-pill);\n  padding: 8px 14px;\n  font-size: 13px;\n  box-shadow: var(--vb-shadow-sm);\n  color: var(--vb-text);\n}\n\n.offline-status.offline {\n  background: var(--vb-warning-soft);\n  border-color: color-mix(in srgb, var(--vb-warning) 40%, transparent);\n}\n\n.offline-status.pending { background: var(--vb-primary-soft); }\n.offline-status.failed { background: var(--vb-danger-soft); }\n.offline-status.syncing,\n.offline-status.online { background: var(--vb-success-soft); }\n\n.status-main {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.status-icon { font-size: 16px; }\n.offline-status.syncing .status-icon { animation: spin 1s linear infinite; }\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.status-text { flex: 1; font-weight: 650; }\n\n.sync-button,\n.sync-action-button {\n  background: var(--vb-primary);\n  color: var(--vb-primary-contrast);\n  border: none;\n  border-radius: var(--vb-radius-pill);\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.sync-button:disabled,\n.sync-action-button:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.details-toggle {\n  background: none;\n  border: none;\n  color: inherit;\n  font-size: 12px;\n  cursor: pointer;\n  padding: 2px 6px;\n  font-weight: 650;\n}\n\n.sync-message,\n.sync-details {\n  margin-top: 8px;\n  padding: 8px 10px;\n  background: var(--vb-surface-2);\n  border-radius: 10px;\n  font-size: 12px;\n  color: var(--vb-text-muted);\n}\n\n.sync-error,\n.sync-errors {\n  margin-top: 8px;\n  padding: 8px;\n  background: var(--vb-danger-soft);\n  border-radius: 10px;\n  color: var(--vb-danger);\n  font-size: 12px;\n}\n\n.sync-details-header,\n.sync-errors-header { font-weight: 700; margin-bottom: 6px; color: var(--vb-text); }\n\n.sync-detail-item {\n  display: flex;\n  justify-content: space-between;\n  margin: 4px 0;\n  font-size: 12px;\n}\n\n.sync-detail-item .online { color: var(--vb-success); }\n.sync-detail-item .offline { color: var(--vb-danger); }\n\n.error-match { font-weight: 650; }\n.error-message { margin-left: 4px; }\n\n.sync-actions {\n  margin-top: 8px;\n  display: flex;\n  gap: 8px;\n}\n\n@media (max-width: 768px) {\n  .offline-status {\n    margin: 10px 12px 0;\n    border-radius: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
